<template>

    <gestion-gasto-form :idBusiness="idBusiness" :idGasto="idGasto" :vista="vista"></gestion-gasto-form>

</template>

<script>

    import GestionGastoForm from "./GestionGastoForm";


    export default {
        components: {GestionGastoForm},

        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                idGasto: this.$route.params.idGasto,
                vista:this.$route.params.vista,
            }
        },
        created() {
        }
    }


</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Gastos/GestionGasto.vue